// src/redux/sagas/menuItemDetailsSaga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import {
  fetchMenuItemDetailsRequest,
  fetchMenuItemDetailsSuccess,
  fetchMenuItemDetailsFailure,
} from '../slices/menuItemDetailsSlice';

// API Response interface
interface MenuItemDetailsApiResponse {
  success: boolean;
  message: string;
  data: {
    items: any[];
    categories: any[];
    modifiers: any[];
  };
  error: null;
}

function* fetchMenuItemDetailsSaga(action: PayloadAction<string>): any {
  try {
    const itemId = action.payload;
    
    // Call API directly
    const response = yield call(request<MenuItemDetailsApiResponse>, {
      method: 'GET',
      url: `${ENDPOINTS.MENU_ITEM_DETAILS_API_PATH}/${itemId}`,
      base: ENDPOINTS.API_V2_BASE_URL,
    });

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch menu item details');
    }
    
    yield put(fetchMenuItemDetailsSuccess(response.data.data));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch menu item details';
    yield put(fetchMenuItemDetailsFailure(errorMessage));
  }
}

export function* watchMenuItemDetailsSaga() {
  yield takeEvery(fetchMenuItemDetailsRequest.type, fetchMenuItemDetailsSaga);
}
